module.exports = "/_next/static/images/m-journal-71439e567de45e6725f63f81d18a25de.png";